import { NavLink, Outlet } from "react-router-dom";
import { Logo } from "./Logo";
import { config } from "../lib/config";
import { navigation } from "../lib/constants";

export function PublicLayout() {
  return (
    <div className="min-h-screen bg-white text-graphite">
      <header className="border-b border-line bg-white">
        <div className="container flex min-h-[76px] items-center justify-between gap-4 py-2 md:py-0">
          <NavLink to="/" aria-label="الرئيسية">
            <Logo />
          </NavLink>
          <nav className="hidden items-center gap-1 lg:flex" aria-label="التنقل الرئيسي">
            {navigation.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2 text-sm font-bold transition ${
                    isActive
                      ? "bg-sand text-charcoal"
                      : "text-ash hover:bg-sand hover:text-charcoal"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <span className="hidden sm:inline-flex">
              <NavLink className="btn btn-primary" to="/request-evaluation">
                طلب تقييم أصول عقارية
              </NavLink>
            </span>
            <details className="relative lg:hidden">
              <summary
                aria-label="فتح القائمة"
                className="grid h-11 w-11 cursor-pointer list-none place-items-center rounded-md border border-line text-charcoal"
              >
                ☰
              </summary>
              <nav className="absolute left-0 top-14 grid w-64 gap-1 rounded-lg border border-line bg-white p-3 shadow-soft">
                {navigation.map((item) => (
                  <NavLink
                    key={item.href}
                    to={item.href}
                    className="rounded-md px-3 py-2 text-sm font-bold text-graphite hover:bg-sand"
                  >
                    {item.label}
                  </NavLink>
                ))}
              </nav>
            </details>
          </div>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="bg-charcoal py-12 text-white">
        <div className="container grid gap-10 md:grid-cols-[1.3fr_0.8fr_0.9fr]">
          <div>
            <Logo />
            <p className="mt-5 max-w-xl text-sm leading-8 text-white/68">
              شركة كيان الاستشارات الهندسية تقدم خدمات هندسية متخصصة، ومن
              ضمنها وحدة تقييم الأصول العقارية للجهات البنكية والتمويلية
              والتأمينية داخل المملكة.
            </p>
          </div>
          <div>
            <h2 className="mb-3 text-base font-bold">الصفحات</h2>
            <div className="grid gap-2 text-sm text-white/72">
              {navigation.slice(1, 6).map((item) => (
                <NavLink key={item.href} to={item.href} className="hover:text-gold">
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
          <div>
            <h2 className="mb-3 text-base font-bold">التواصل</h2>
            {config.contactEmail ? (
              <a
                className="text-sm font-bold text-white/72 transition hover:text-gold"
                href={`mailto:${config.contactEmail}`}
              >
                {config.contactEmail}
              </a>
            ) : (
              <p className="text-sm leading-8 text-white/72">
                سيتم تحديث بيانات التواصل الرسمية قريباً.
              </p>
            )}
            <p className="mt-4 text-sm leading-8 text-white/60">
              تقييم هندسي للحالة الفنية والأضرار وتكلفة الإصلاح، دون تقدير
              القيمة السوقية للعقار.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
